// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#message-board[data-v-4bfe0d4e]  .nav-tabs .nav-link{padding-right:2.5rem;padding-left:2.5rem}", ""]);
// Exports
module.exports = exports;
